import React from "react";
import Form from 'react-bootstrap/Form';

const TrackTable = () => {
  return (
    <>
      <section className="about-area pb-60 pt-60">
        <div className="container">
        <h2 className='pb-1' data-aos="fade-up" data-aos-delay="100">NASCAR CUP SERIES STATS, DRIVER, TRACK, OWNER, MANUFACTURER STATS</h2>

          <div className="row">
            <div className="col-xl-12">
              <div
                className="banner-filter-form mt-40"
                data-aos="fade-up"
                data-aos-delay="100"
              >

                <div className="card p-30 shadow-lg bg-dark">
                  <form action="#">
                    <div className="row align-items-center justify-content-center">
                      <div className="col-lg-12">
                        <div className="row">
                          <Form.Group className="mb-1">
                            <Form.Label className="field-title color-light">
                            Show only tracks from the following series:
                            </Form.Label>
                            <Form.Select>
                              <option>All Series</option>
                              <option>A1 Grand Prix</option>
                              <option>ABB Formula E Series</option>
                              <option>ACT Late Model Tour</option>
                              <option>American Le Mans Series</option>
                            </Form.Select>
                          </Form.Group>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <table className="table  table-dark table-striped table-bordered border-light">
            <thead>
              <tr style={{ width: "100%" }}>
                <th scope="col" style={{ width: "40%" }}>
                  TRACK
                </th>
                <th scope="col" style={{ width: "20%" }}>
                  LOCATION
                </th>
                <th scope="col" style={{ width: "10%" }}>
                  COUNTRY
                </th>
                <th scope="col" style={{ width: "10%" }}>
                  FIRST RACE
                </th>
                <th scope="col" style={{ width: "10%" }}>
                  LAST RACE
                </th>
                <th scope="col" style={{ width: "10%" }}>
                  # RACE
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">Air Base Speedway</th>
                <td>Greenville, SC</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>1</td>
              </tr>
              <tr>
                <th scope="row">Airborne Speedway</th>
                <td>Plattsburgh, NY</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1955</td>
                <td style={{ textAlign: "center" }}>1955</td>
                <td style={{ textAlign: "center" }}>1</td>
              </tr>
              <tr>
                <th scope="row">Albany-Saratoga Speedway</th>
                <td>Malta, NY</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1970</td>
                <td style={{ textAlign: "center" }}>1971</td>
                <td style={{ textAlign: "center" }}>2</td>
              </tr>
              <tr>
                <th scope="row">Air Base Speedway</th>
                <td>Greenville, SC</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>2</td>
              </tr>
              <tr>
                <th scope="row">Air Base Speedway</th>
                <td>Greenville, SC</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>3</td>
              </tr>
              <tr>
                <th scope="row">Airborne Speedway</th>
                <td>Plattsburgh, NY</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1955</td>
                <td style={{ textAlign: "center" }}>1955</td>
                <td style={{ textAlign: "center" }}>3</td>
              </tr>
              <tr>
                <th scope="row">Albany-Saratoga Speedway</th>
                <td>Malta, NY</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1970</td>
                <td style={{ textAlign: "center" }}>1971</td>
                <td style={{ textAlign: "center" }}>4</td>
              </tr>
              <tr>
                <th scope="row">Air Base Speedway</th>
                <td>Greenville, SC</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>4</td>
              </tr>
              <tr>
                <th scope="row">Air Base Speedway</th>
                <td>Greenville, SC</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>5</td>
              </tr>
              <tr>
                <th scope="row">Airborne Speedway</th>
                <td>Plattsburgh, NY</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1955</td>
                <td style={{ textAlign: "center" }}>1955</td>
                <td style={{ textAlign: "center" }}>5</td>
              </tr>
              <tr>
                <th scope="row">Albany-Saratoga Speedway</th>
                <td>Malta, NY</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1970</td>
                <td style={{ textAlign: "center" }}>1971</td>
                <td style={{ textAlign: "center" }}>6</td>
              </tr>
              <tr>
                <th scope="row">Air Base Speedway</th>
                <td>Greenville, SC</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>6</td>
              </tr>
              <tr>
                <th scope="row">Air Base Speedway</th>
                <td>Greenville, SC</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>7</td>
              </tr>
              <tr>
                <th scope="row">Airborne Speedway</th>
                <td>Plattsburgh, NY</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1955</td>
                <td style={{ textAlign: "center" }}>1955</td>
                <td style={{ textAlign: "center" }}>7</td>
              </tr>
              <tr>
                <th scope="row">Albany-Saratoga Speedway</th>
                <td>Malta, NY</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1970</td>
                <td style={{ textAlign: "center" }}>1971</td>
                <td style={{ textAlign: "center" }}>8</td>
              </tr>
              <tr>
                <th scope="row">Air Base Speedway</th>
                <td>Greenville, SC</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>8</td>
              </tr>
              <tr>
                <th scope="row">Air Base Speedway</th>
                <td>Greenville, SC</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>9</td>
              </tr>
              <tr>
                <th scope="row">Airborne Speedway</th>
                <td>Plattsburgh, NY</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1955</td>
                <td style={{ textAlign: "center" }}>1955</td>
                <td style={{ textAlign: "center" }}>9</td>
              </tr>
              <tr>
                <th scope="row">Albany-Saratoga Speedway</th>
                <td>Malta, NY</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1970</td>
                <td style={{ textAlign: "center" }}>1971</td>
                <td style={{ textAlign: "center" }}>9</td>
              </tr>
              <tr>
                <th scope="row">Air Base Speedway</th>
                <td>Greenville, SC</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>10</td>
              </tr>
              <tr>
                <th scope="row">Air Base Speedway</th>
                <td>Greenville, SC</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>10</td>
              </tr>
              <tr>
                <th scope="row">Airborne Speedway</th>
                <td>Plattsburgh, NY</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1955</td>
                <td style={{ textAlign: "center" }}>1955</td>
                <td style={{ textAlign: "center" }}>11</td>
              </tr>
              <tr>
                <th scope="row">Albany-Saratoga Speedway</th>
                <td>Malta, NY</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1970</td>
                <td style={{ textAlign: "center" }}>1971</td>
                <td style={{ textAlign: "center" }}>11</td>
              </tr>
              <tr>
                <th scope="row">Air Base Speedway</th>
                <td>Greenville, SC</td>
                <td style={{ textAlign: "center" }}>MX</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>1951</td>
                <td style={{ textAlign: "center" }}>11</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
};

export default TrackTable;
